import React from "react";

const Index = () => {
  return (
    <section id="about" className="relative bg-white text-white py-10 md:py-52 px-8">
      <div className="container mx-auto flex flex-col items-center text-center">
        <h3 className="text-5xl font-extrabold mb-10 text-primary animate-fade-in-down">
          About Us
        </h3>
        <p className="text-lg max-w-4xl mx-auto mb-6 leading-relaxed text-secondary animate-fade-in-up">
        Driven by our mission to "Empowering E-Commerce and Beyond with Innovative Software and AI Solutions," Commerce Minder is a technology company dedicated to enhancing business value in the digital transformation era. Our flagship product, ToptanTR, is an advanced mobile and web-compatible B2B platform that optimizes business processes in wholesale commerce, offering innovative solutions to help businesses achieve their commercial goals more efficiently and effectively.
        </p>
        <p className="text-lg max-w-4xl mx-auto mb-10 leading-relaxed text-secondary animate-fade-in-up">
          Commerce Minder serves not only as a product provider but also as a trusted solution partner with profound software and technical
          expertise in e-commerce, particularly within the B2B sector. Our services address the unique needs of B2B e-commerce, supporting
          businesses in boosting operational efficiency and gaining a competitive edge.
        </p>
        <p className="text-lg max-w-4xl mx-auto mb-10 leading-relaxed text-secondary animate-fade-in-up">
        With our expertise in software development, engineering, and AI solutions, we deliver technology solutions that drive sustainable growth and contribute to the success of our clients. At Commerce Minder, we take pride in standing by businesses on their digital journey, fostering innovation and building partnerships rooted in trust.
        </p>
        <div className="flex space-x-6">
          <button className="bg-primary text-white font-bold py-3 px-8 rounded-full shadow-lg hover:bg-white hover:text-primary border transition-all duration-300">
            Learn More
          </button>
          <a href="#contact">
            <button className="bg-transparent border border-primary text-primary font-bold py-3 px-8 rounded-full shadow-lg hover:bg-primary hover:text-white transition-all duration-300">
              Contact Us
            </button>
          </a>
        </div>
        <div className="absolute inset-0 w-full h-full pointer-events-none opacity-20">
          <svg
            className="w-full h-full"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 800 800"
            fill="none"
          >
            <circle cx="400" cy="400" r="350" stroke="blue" strokeWidth="0.5" />
            <circle cx="400" cy="400" r="300" stroke="blue" strokeWidth="0.5" />
            <circle cx="400" cy="400" r="250" stroke="blue" strokeWidth="0.5" />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Index;
